import { NgModule } from '@angular/core';
import { PrizmInputHintDirective } from './input-hint.directive';

@NgModule({
  declarations: [PrizmInputHintDirective],
  exports: [PrizmInputHintDirective],
})
export class PrizmInputHintModule {}
